function persistPageState(payload = {}, key = '') {
  let name = key != '' ? key : window.location.pathname
  localStorage.setItem(name, JSON.stringify(payload))
}

export default persistPageState
